/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignatureInstanceResponse
 */
export interface SignatureInstanceResponse {
    /**
     * 
     * @type {string}
     * @memberof SignatureInstanceResponse
     */
    resultCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureInstanceResponse
     */
    resultMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureInstanceResponse
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureInstanceResponse
     */
    binding?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureInstanceResponse
     */
    relayState?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureInstanceResponse
     */
    eidSignRequest?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureInstanceResponse
     */
    signatureInstanceId?: string;
}

export function SignatureInstanceResponseFromJSON(json: any): SignatureInstanceResponse {
    return SignatureInstanceResponseFromJSONTyped(json, false);
}

export function SignatureInstanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureInstanceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultCode': !exists(json, 'resultCode') ? undefined : json['resultCode'],
        'resultMessage': !exists(json, 'resultMessage') ? undefined : json['resultMessage'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'binding': !exists(json, 'binding') ? undefined : json['binding'],
        'relayState': !exists(json, 'relayState') ? undefined : json['relayState'],
        'eidSignRequest': !exists(json, 'eidSignRequest') ? undefined : json['eidSignRequest'],
        'signatureInstanceId': !exists(json, 'signatureInstanceId') ? undefined : json['signatureInstanceId'],
    };
}

export function SignatureInstanceResponseToJSON(value?: SignatureInstanceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resultCode': value.resultCode,
        'resultMessage': value.resultMessage,
        'action': value.action,
        'binding': value.binding,
        'relayState': value.relayState,
        'eidSignRequest': value.eidSignRequest,
        'signatureInstanceId': value.signatureInstanceId,
    };
}

